var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn p-0 btn-link",attrs:{"type":"button","id":_vm.id},on:{"click":_vm.action}},[_c('img',{staticStyle:{"margin-left":"2px","margin-bottom":"3px"},attrs:{"src":require("@/assets/icons/plus1.svg")}}),(_vm.withText)?_c('span',{staticClass:"f-16 f-semi f-c-blue p-l-8"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }